import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { useState, useEffect } from 'react';

const UsersList = () => {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem('jwt_token');
    const [usersList, setUsersList] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [totalUsers, setTotalUsers] = useState(0);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const usersPerPage = 10;

    const handleSearch = (e) => {
        const searchTerm = e.target.value.toLowerCase();
        const filtered = usersList.filter((user) =>
            user.comp_name.toLowerCase().includes(searchTerm) ||
            user.emp_code.toLowerCase().includes(searchTerm) ||
            user.role.toLowerCase().includes(searchTerm)
        );
        setFilteredUsers(filtered);
        setCurrentPage(1); // Reset to first page after filtering
    };

    useEffect(() => {
        const fetchUsersList = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}api/getUsersList`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });
                const data = await response.json();
                if (data && data.data) {
                    setUsersList(data.data);
                    setFilteredUsers(data.data);
                    setTotalUsers(data.data.length);
                }
                setLoading(false);
            } catch (error) {
                console.error('Error:', error);
                setLoading(false);
            }
        };
        fetchUsersList();
    }, [API_BASE_URL, token]);

    // Pagination logic
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="wrapper">
            <Sidebar />
            <main className="main-content content-page">
                <div className="position-relative">
                    <Navbar />
                </div>
                <div className="content-inner container-fluid pb-0" id="page_layout">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header-custom d-flex justify-content-between p-4 mb-0 row">
                                    <div className="header-title col-4">
                                        <h4 className="card-title">Users List</h4>
                                    </div>
                                    <div className="header-action col-8">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group mb-0">
                                                    <input type="text" className="form-control form-control-sm" onChange={handleSearch} placeholder="Search" />
                                                </div>
                                            </div>
                                            <div className="col-6 d-flex justify-content-end">
                                                <a href="/add_user" className="btn btn-sm btn-primary">Add User</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Employee Code</th>
                                                <th>Role</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentUsers.map((user, index) => (
                                                <tr key={user.id}>
                                                    <td>{indexOfFirstUser + index + 1}</td>
                                                    <td>{user.comp_name}</td>
                                                    <td>{user.emp_code}</td>
                                                    <td>{user.role}</td>
                                                    <td>
                                                        <a href={`/edit_user/${user.emp_code}`} className="btn btn-sm btn-primary">
                                                            <i className="fa fa-pencil"></i>
                                                        </a>&nbsp;
                                                        {/* <a href="#" className="btn btn-sm btn-danger">
                                                            <i className="fa fa-trash"></i>
                                                        </a> */}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {/* Pagination */}
                                <div className="d-flex justify-content-between align-items-center p-3">
                                    <button
                                        className="btn btn-sm btn-secondary"
                                        onClick={() => paginate(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </button>
                                    <span>Page {currentPage} of {Math.ceil(filteredUsers.length / usersPerPage)}</span>
                                    <button
                                        className="btn btn-sm btn-secondary"
                                        onClick={() => paginate(currentPage + 1)}
                                        disabled={indexOfLastUser >= filteredUsers.length}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default UsersList;
